'use client';
import { jsx } from 'react/jsx-runtime';
import '@digdir/designsystemet-web';
import { forwardRef } from 'react';

/**
 * The container for all `Tab` components.
 *
 * @example
 * <TabsList>
 *  <TabsTab value='1'>Tab 1</TabsTab>
 *  <TabsTab value='2'>Tab 2</TabsTab>
 * </TabsList>
 */
const TabsList = forwardRef(function TabsList({ className, children, ...rest }, ref) {
    return (jsx("ds-tablist", { suppressHydrationWarning // Since <ds-tablist> adds attributes
        : true, ref: ref, class: className, ...rest, children: children }));
});

export { TabsList };
